export class AppConstants {
  public static APP_AUTH='auth';
  public static APP_DATE_TIME='dd/MM/yyyy hh:mm';


  public static API_SUCCESS_CODE='200';
  public static API_BAD_REQUEST_CODE='400';

  public static EXCEL_MAX_FILE_SIZE= 50; // 300MB
}
